import Vue from 'vue'
import './plugins/config'
import store from './store'
import router from './router'
import './plugins/axios'
import i18n from './langs'
import _MIXINS_ from './mixins'
import App from './App.vue'
import './plugins/iview.js'
import './plugins/rsa.js'
// import './plugins/common.js'
import './assets/css/iview.less'
import './assets/css/common.less'


Vue.config.productionTip = false

window._MIXINS_ = _MIXINS_

window.addEventListener('popstate', function() {
	history.pushState(null, null, document.URL)
})  

router.beforeEach((to, from, next) => {
    // to:目标路由
    // from:源路由
    // next:下一步的操作，就是用户当前需要进行的操作
	// console.log(sessionStorage.getItem('token'));
	
    // if(to.name !== 'Login'){
	// 	if(sessionStorage.getItem('token')){
	// 		var idCheckResultStatus = sessionStorage.getItem('idCheckResultStatus')
	// 		debugger
	// 		if(idCheckResultStatus == 1 || idCheckResultStatus == 0){
	// 			next({ path:'/accountVerify'})
	// 		}else if(idCheckResultStatus == 3){
	// 			next({ path:'/verifyError'})
	// 		}else{
	// 			next()
	// 		}
	// 	}else{
	// 		next()
	// 	}
	// }else{
	// 	next()
	// }
	if (to.meta.requireAuth) { // 查看请求是否需要认证
		if (sessionStorage.getItem('token')) { // 有权限,继续往下跳转
			// console.log(from)
			if(from.path !== '/login'){
				var idCheckResultStatus = sessionStorage.getItem('idCheckResultStatus')
				if (to.path == '/accountVerify') {
					if(idCheckResultStatus == 1 || idCheckResultStatus == 0){
						next()
					}else if(idCheckResultStatus == 3){
						next('/verifyError')
					}else {
						next('myAccount')
					}
				}else if(to.path == '/verifyError'){
					if(idCheckResultStatus == 3){
						next()
					}if(idCheckResultStatus == 1 || idCheckResultStatus == 0){
						next('/accountVerify')
					}else{
						next('myAccount')
					}
				}else{
					if(idCheckResultStatus == 3){
						next('/verifyError')
					}else if(idCheckResultStatus == 1 || idCheckResultStatus == 0){
						if (to.path == '/uploadPhoto') {
							next()
						}else{
							next('/accountVerify')
						}
					}else{
						next()
					}
				}
			}else{
				next()
			}
		}else{
			if (to.path == '/login') {//token不存在，并且是login页面
				next();
			} else {//token不存在，不是login页面
				next('/login');
			}
		}
	} else { // 不需要认证的全部直接放行
		next();
	}

})

new Vue({
	store,
	router,
	i18n,
	render: h => h(App)
}).$mount('#app')
